__turbopack_context__.v({
  "a": "styles-module__8FS8Tq__a",
  "b": "styles-module__8FS8Tq__b",
  "c": "styles-module__8FS8Tq__c",
  "pattern": "styles-module__8FS8Tq__pattern",
});
